module.exports = __webpack_public_path__ + "img/BreakfastAtGranddad.3e67a2c2.svg";